/**
 * Validates redirect path to prevent open-redirect attacks.
 * Allowed: path starts with "/", not "//", must not contain http(s) schemes.
 * Rejects /login to prevent redirect loops.
 */
export function isValidRedirect(path: string): boolean {
  if (!path || typeof path !== 'string') return false;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return false;
  if (trimmed.includes('http://') || trimmed.includes('https://')) return false;
  // Prevent redirect loop: do not redirect back to login
  if (trimmed === '/login' || trimmed.startsWith('/login?')) return false;
  return true;
}
